import SuspenseBoundary from "../../components/SuspenseBoundary";
import { LinearProgress, Stack, Tab, Tabs } from "@mui/material";
import Title from "../../components/Title";
import { Outlet, useMatches, useParams } from "react-router";
import BerechtigungenContextProvider from "../../components/PermissionsContext";
import Container from "../../components/Container";
import LinkBehavior from "../../components/LinkBehavior";
import { useServoTyp } from "./data";
import ServoTypLabel from "../../components/ServoTypLabel";

export default function ServoTypDetails() {
  const { servoTypId = "" } = useParams<{ servoTypId: string }>();
  return (
    <SuspenseBoundary
      fallback={
        <Stack spacing={2}>
          <Title title="Servo Type">Lade ServoTyp&hellip;</Title>
          <LinearProgress />
        </Stack>
      }
    >
      <ServoTypContent servoTypId={servoTypId} />
    </SuspenseBoundary>
  );
}

function ServoTypContent({ servoTypId }: { servoTypId: string }) {
  const servoTyp = useServoTyp(servoTypId);
  const tab = useActiveTab();

  return (
    <BerechtigungenContextProvider berechtigungen={servoTyp.berechtigungen}>
      <Stack>
        <Title back=".." title={["Servo Typen", servoTyp.produktnummer]}>
          ServoTyp <ServoTypLabel servoTyp={servoTyp} />
        </Title>
        <Container>
          <Tabs value={tab}>
            <Tab
              component={LinkBehavior}
              label="Zugeordnete Testszenarios"
              value="testszenarios"
              href="testszenarios"
            />
          </Tabs>
          <SuspenseBoundary>
            <Outlet context={{ servoTyp }} />
          </SuspenseBoundary>
        </Container>
      </Stack>
    </BerechtigungenContextProvider>
  );
}

function useActiveTab() {
  // FIXME: this is super ugly and brittle.
  // Can we get the curent tab in a more stable way?
  return useMatches()[3].pathname.split(/\//)[3];
}
